import React, {useState} from 'react';

const Range = ({filter, group, dispatch, multiScreen}) => {
  const [minValue, setMinValue] = useState(filter?.value?.min || '');
  const [maxValue, setMaxValue] = useState(filter?.value?.max || '');

  return (
    <div className="flex flex-col w-full  gap-2">
      <label
        htmlFor="symbol"
        className={`${
          multiScreen ? 'text-sm font-bold' : 'text-md'
        } block  font-medium text-gray-700`}
      >
        Filter By {filter?.title}
      </label>
      <div className="flex gap-2">
        <div className="flex flex-col gap-2 w-full">
          {!multiScreen ? (
            <label
              htmlFor="name"
              className="block text-sm font-medium text-gray-900 range-label"
            >
              Min
            </label>
          ) : null}
          <div className="border border-gray-300 rounded-md bg-white px-2 py-1 shadow-sm focus-within:ring-1 focus-within:ring-transparent focus-within:border-gray-300 ">
            <input
              min={filter?.filterable?.floor ?? 0}
              type={filter?.type ?? 'number'}
              name={filter?.key}
              id={filter?.key}
              className={`${
                multiScreen ? 'text-sm' : 'text-md'
              } block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0`}
              placeholder={
                filter?.filterable?.placeholder?.low ??
                `Min ${
                  filter?.filterable?.floor
                    ? `(${filter?.filterable?.floor} minimum)`
                    : ''
                }`
              }
              onChange={(e) => {
                const value = Number(e.target.value);
                const minValueNum = Number(filter?.filterable?.floor);

                dispatch({
                  type: 'UPDATE_FILTER_VALUES',
                  payload: {
                    updatedValue:
                      value < minValueNum && !Number.isNaN(minValueNum)
                        ? minValueNum
                        : value ?? '',
                    key: filter?.key,
                    minMax: 'min',
                    group,
                  },
                });
                setMinValue(
                  value < minValueNum && !Number.isNaN(minValueNum)
                    ? minValueNum
                    : value ?? '',
                );
              }}
              value={minValue || ''}
            />
          </div>
          {multiScreen ? (
            <label
              htmlFor="name"
              className={`${
                multiScreen ? 'range-label-multi' : ''
              } block text-xs font-medium text-gray-900 range-label`}
            >
              Min
            </label>
          ) : null}
        </div>
        <div className="flex flex-col gap-2 w-full">
          {!multiScreen ? (
            <label
              htmlFor="name"
              className="block text-sm font-medium text-gray-900 range-label"
            >
              Max
            </label>
          ) : null}
          <div className="border border-gray-300 rounded-md bg-white px-2 py-1 shadow-sm focus-within:ring-1 focus-within:ring-transparent focus-within:border-gray-300 ">
            <input
              type={filter?.type ?? 'number'}
              name={filter?.key}
              id={filter?.key}
              min={0}
              className={`${
                multiScreen ? 'text-sm' : 'text-md'
              } block w-full border-0 p-0 text-gray-900 placeholder-gray-500 focus:ring-0`}
              placeholder={filter?.filterable?.placeholder?.high ?? 'Max'}
              onChange={(e) => {
                const value = Number(e.target.value);
                const maxValueNum = Number(filter?.filterable?.minMax);

                dispatch({
                  type: 'UPDATE_FILTER_VALUES',
                  payload: {
                    updatedValue:
                      value > maxValueNum && !Number.isNaN(maxValueNum)
                        ? maxValueNum
                        : value ?? '',
                    key: filter?.key,
                    minMax: 'max',
                    group,
                  },
                });
                setMaxValue(
                  value > maxValueNum && !Number.isNaN(maxValueNum)
                    ? maxValueNum
                    : value ?? '',
                );
              }}
              value={maxValue || ''}
            />
          </div>
          {multiScreen ? (
            <label
              htmlFor="name"
              className={`${
                multiScreen ? 'range-label-multi' : ''
              } block text-xs font-medium text-gray-900 range-label`}
            >
              Max
            </label>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Range;
